import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import { VbLoadingService } from '@/shared/loading/loading.service';
import Axios from 'axios';
import * as msal from '@/plugins/msal';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.use(msal);
Vue.use(VueTheMask);

Vue.prototype.$paginationSize = [5, 10, 15, 30, 45, 60, 100, 150, 200];

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

Axios.interceptors.request.use((config) => {
  VbLoadingService.show();
  return config;
})

Axios.interceptors.response.use((config) => {
  VbLoadingService.hide();
  return config;
}, (err) => {
  VbLoadingService.hide();
  throw err;
})
